import { render, staticRenderFns } from "./ProductPackageSetting.vue?vue&type=template&id=83ac73a8&scoped=true"
import script from "./ProductPackageSetting.vue?vue&type=script&lang=js"
export * from "./ProductPackageSetting.vue?vue&type=script&lang=js"
import style0 from "./ProductPackageSetting.vue?vue&type=style&index=0&id=83ac73a8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ac73a8",
  null
  
)

export default component.exports